module.exports = __webpack_public_path__ + "static/media/alerta.3c4d5a08.svg";